module.exports = __webpack_public_path__ + "img/close.447715b0.svg";